// extracted by mini-css-extract-plugin
export default {"container":"PageTitle_container__0NC+d","title":"PageTitle_title__Ymqaa","description":"PageTitle_description__YijE1"};